module.exports = __webpack_public_path__ + "img/link.eda9cdbf.svg";